import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import contact from '@/store/shared/contact'
import details from './details'
import thirdPartyInvoices from '@/store/shared/thirdPartyAttached'
import discountsCharges from '@/store/shared/discounts'
import paymentsSpentsOthers from '@/store/shared/others'
import paymentIndications from './paymentIndications'
import files from '@/store/shared/files'
/** Factoring */
import factoringContact from '@/store/invoice/factoringContact'
import factoringReferences from '@/store/invoice/factoringReferences'
import factoringTransferDocuments from '@/store/invoice/factoringTransferDocuments'
import factoringPaymentData from '@/store/invoice/factoringPaymentData'

import dire from '@/store/shared/dire'

import { formatNow } from '@/helpers/formatDate'

export default {
  namespaced: true,
  state () {
    return {
      id: undefined,
      invoiceId: {
        serie: undefined,
        number: undefined
      },
      type: 'STANDARD',
      onlySupplied: false,
      format: 'CM10',
      created: formatNow(),
      issue: null,
      incomeDate: null,
      billPeriod: {
        start: null,
        end: null
      },
      billProcedure: {
        serie: undefined,
        reason: '1'
      },
      concept: undefined,
      customerAsClient: true,
      fundProvision: undefined,
      me: undefined,
      paidRectified: {
        rectifiedId: undefined,
        serie: undefined,
        number: undefined,
        reason: '1',
        description: undefined
      },
      editing: false,
      loaded: false,
      toRectify: false,
      toDuplicate: false,
      status: undefined,
      locatorCode: undefined,
      _invoiceType: undefined,
      doBillPeriod: false,
      doBillProcedure: false,
      checkInmobilized: false,
      showInvoiceAssets: false,
      suppliedToEdit: false,
      doBillId: true
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    provider: contact,
    agent: contact,
    client: contact,
    customer: contact,
    details,
    discountsCharges,
    paymentsSpentsOthers,
    thirdPartyInvoices,
    paymentIndications,
    files,
    // factoring
    factoringContact,
    factoringReferences,
    factoringTransferDocuments,
    factoringPaymentData,
    // faceb2b
    FACeB2B: dire
  }
}
